import {
  RouteProps,
  RouteComponentProps,
  Redirect,
  Route,
} from "react-router-dom";
import React from "react";
import { AuthService } from "./api/AuthService";

type AuthRouteProps = RouteProps;

export class NoAuthRoute extends React.PureComponent<AuthRouteProps> {
  render() {
    const { children, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={({ location }) =>
          AuthService.checkAuth() ? (
            <Redirect
              to={{
                pathname: "/dashboard",
                state: { from: location },
              }}
            />
          ) : (
            children
          )
        }
      />
    );
  }
}
